import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InvoiceDeleteDialogComponent } from './invoice-delete.dialog';

@Injectable({
  providedIn: 'root'
})
export class InvoiceDeleteDialogService {

    constructor(public dialog: MatDialog) {}

    public open(invoiceNumber: number, callback: any) {
        const invoiceData = { number: invoiceNumber };
        let dialog = this.dialog.open(InvoiceDeleteDialogComponent, {
            width: '400px',
            data: {
                invoice: invoiceData
            }
        });

        dialog.afterClosed().subscribe(r => {
            callback();
        })
    }
}
